<template>
    <form name="contactform">
        <div class="page intro elementStandard elementContent elementForm elementForm_var0">

            <!-- SHOW REGISTER FORM -->
            <div tabindex="-1" role="dialog" class="modal fade ng-isolate-scope in"
                style="z-index: 1050; display: block;" v-if="!showLogin">
                <div class="modal-dialog ">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title">{{ __("dialog_login.registertitle") }}</h3>
                        </div>
                        <div class="modal-body">
                            <div><p>
                                {{ __("page_setcontact.createaccount_desc") }}
                            </p></div>
                            
                            <dl class="form" id="loginRegisterForm">

                                <div class="label-input">
                                    <dt>
                                        <label for="email" class="col-sm-2 control-label required">
                                            {{ __('page_setcontact.email') }}
                                        </label>
                                    </dt>
                                    <dd>
                                        <input type="email" class="inputText XL" v-model="contact.email"
                                        @input="() => validators.contact.validateEmail()">
                                        <div class="errorMessages" v-if="validators.contact.errors.email">
                                            <ErrorMessage>{{__(validators.contact.errors.email)}}</ErrorMessage>
                                        </div>
                                    </dd>
                                </div>

                                <div class="label-input">
                                    <dt>
                                        <label for="password" class="col-sm-2 control-label labelText required" >{{ __('page_setcontact.password') }}</label>
                                    </dt>
                                    <dd>
                                        <input type="password" class="inputText XL" v-model="password"/>
                                        <div class="errorMessages" v-if="validators.password.errors.password">
                                            <ErrorMessage>{{__(validators.password.errors.password)}}</ErrorMessage>
                                        </div>
                                    </dd>
                                </div>

                                <div class="label-input">
                                    <dt>
                                        <label class="required labelText">{{ __('page_setcontact.passwordrepeat') }}</label>
                                    </dt>
                                    <dd>
                                        <input type="password" class="inputText XL" v-model="confirmPassword"/>
                                        <div class="errorMessages" v-if="validators.password.errors.confirmPassword">
                                            <ErrorMessage>{{__(validators.password.errors.confirmPassword)}}</ErrorMessage>
                                        </div>
                                    </dd>
                                </div>

                            </dl>
                        </div>
                    </div>
                </div>
            </div>

            <Login @login-register-status="loginRegisterStatus($event)" @loginSuccess="loginSuccess($event)" v-if="!registration.interessent_id"></Login>

            <button type="button" class="btn-secondary right mt-8" @click="registration.interessent_id = null; showLogin=true;"
                    v-if="registration.interessent_id">
                {{ $store.language === 'de' ? 'Ausloggen' : 'Logout' }}
            </button>

            <!-- SHOW CONTACT FORM -->
            <div v-if="!showLogin || (showLogin && registration.interessent_id)">
                <h2>{{ __('page_setcontact.pagetitle') }}</h2>
                <div class="clearBoth"></div>
                <dl class="form" style="max-width: 1000px;">

                    <div style="display: flex; flex-direction: row;" class="justify-center">
                        
                        <div>
                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.company') }}</label>
                            </dt>
                            <dd>
                                <input type="text" class="inputText"
                                    v-model="company.name"
                                    @input="validators.company.validateName()">
                                <div class="errorMessages" v-if="validators.company.errors.name">
                                    <ErrorMessage>{{__(validators.company.errors.name)}}</ErrorMessage>
                                </div>
                            </dd>

                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.country') }}</label>
                            </dt>
                            <dd>
                                <select v-model="company.country" class="inputText"
                                        @change="validators.company.validateCountry()">
                                    <option value="">{{ __('common.please_select') }}</option>
                                    <option v-for="country in countries"
                                            :value="country.val" :key="country.val">{{country.label}}
                                    </option>
                                </select>
                                <div class="errorMessages" v-if="validators.company.errors.country">
                                    <ErrorMessage>{{__(validators.company.errors.country)}}</ErrorMessage>
                                </div>
                            </dd>

                            <dt>
                                <label class="labelText">{{ __('page_setcontact.masterbrewer') }}</label>
                            </dt>
                            <dd>
                                <input type="text" class="inputText" v-model="company.master_brewer">
                            </dd>

                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.address') }}</label>
                            </dt>
                            <dd>
                                <input type="text" class="inputText" v-model="company.street1"
                                    @input="validators.company.validateAddress()">
                            </dd>
                            <dd>
                                <input type="text" class="inputText" v-model="company.street2"
                                    @input="validators.company.validateAddress()">
                                <div class="errorMessages" v-if="validators.company.errors.address">
                                    <ErrorMessage>{{__(validators.company.errors.address)}}</ErrorMessage>
                                </div>
                            </dd>

                            <!-- postcode here COX-233 -->
                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.zipcode') }}</label>
                                <label style="padding-left:30px;" class="required labelText">{{ __('page_setcontact.city') }}</label>
                            </dt>

                            <dd>
                                <input type="text" v-model="company.zip" class="S inputText" @input="validators.company.validateZip()">
                                <input type="text" v-model="company.city" class="L inputText" @input="validators.company.validateCity()">

                                <div class="warningMessage" v-if="validators.company.warnings.zip">
                                    <ErrorMessage style="color: black;">{{__(validators.company.warnings.zip)}}</ErrorMessage>
                                </div>

                                <div class="errorMessages" v-if="validators.company.errors.city">
                                    <ErrorMessage>{{__(validators.company.errors.city)}}</ErrorMessage>
                                </div>

                            </dd>

                            <dt v-if="needsVat">
                                <label  class="required labelText">{{ __('page_setcontact.vatid') }}</label>
                            </dt>
                            <dd v-if="needsVat">
                                <input type="text" v-model="company.vatid" class="inputText">
                                <div class="errorMessages" v-if="validators.vatid.errors.vatid">
                                    <ErrorMessage style="color: black;">{{__(validators.vatid.errors.vatid)}}</ErrorMessage>
                                </div>
                            </dd>

                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.url') }}</label>
                            </dt>
                            <dd>
                                <input type="text" class="inputText"
                                    v-model="company.url_company"
                                    @input="validators.company.validateURL()">
                                <div class="errorMessages" v-if="validators.company.errors.url">
                                    <ErrorMessage>{{__(validators.company.errors.url)}}</ErrorMessage>
                                </div>
                            </dd>

                            <dt>
                                <label class="labelText">{{ __('page_setcontact.ponumber') }}</label>
                            </dt>
                            <dd>
                                <input type="text" class="inputText"
                                    v-model="company.po_number">
                            </dd>
                        </div>
                        <div style="padding-left: 100px;">
                            <fieldset style="border: 2px solid #e0ddd6; padding: 16px">
                                <h2>{{ __('page_setcontact.contact_header') }}</h2>
                                <dt>
                                    <label class="required labelText">{{ __('page_setcontact.salutation') }}</label>
                                </dt>
                                <dd>
                                    <select v-model="contact.salutation" class="inputText"
                                            @change="() => validators.contact.validateSalutation()">

                                        <option value="">{{ __('common.please_select') }}</option>
                                        <option v-for="salutation in salutations"
                                                :value="salutation.value" :key="salutation.value">{{salutation.label}}
                                        </option>
                                    </select>
                                    <div class="errorMessages" v-if="validators.contact.errors.salutation">
                                        <ErrorMessage>{{__(validators.contact.errors.salutation)}}</ErrorMessage>
                                    </div>
                                </dd>

                                <dt>
                                    <label class="S required labelText">{{ __('page_setcontact.firstname') }}</label>
                                    <label class="L required labelText">{{ __('page_setcontact.lastname') }}</label>
                                </dt>
                                <dd>
                                    <input type="text" v-model="contact.firstname" class="S inputText"
                                        @input="() => validators.contact.validateFirstName()">
                                    <input type="text" v-model="contact.lastname" class="L inputText"
                                        @input="() => validators.contact.validateLastName()">
                                    <div class="errorMessages"
                                        v-if="validators.contact.errors.firstname || validators.contact.errors.lastname">
                                        <ErrorMessage>{{__(validators.contact.errors.firstname)}}</ErrorMessage>
                                        <ErrorMessage>{{__(validators.contact.errors.lastname)}}</ErrorMessage>
                                    </div>
                                </dd>
                                <dt>
                                    <label class="labelText">{{ __('page_setcontact.email') }}</label>
                                </dt>
                                <dd>
                                    <input type="text" v-model="contact.email" readonly class="inputText" disabled>
                                    <br>
                                    <span style="font-size:12px">
                                        {{ __('page_setcontact.email-communication') }}
                                    </span>
                                </dd>
                                <dt>
                                    <label class="required labelText">{{ __('page_setcontact.phone') }}</label>
                                </dt>
                                <dd>
                                    <TelephoneInput :country="company.country" v-model="contact.phone" class="inputText" @input="() => validators.contact.validatePhone()"/>

                                    <div class="errorMessages" v-if="validators.contact.errors.phone">
                                        <ErrorMessage>{{__(validators.contact.errors.phone)}}</ErrorMessage>
                                    </div>
                                </dd>

                                <dt>
                                    <label class="labelText">{{ __('page_setcontact.fax') }}</label>
                                </dt>
                                <dd>
                                    <TelephoneInput :country="company.country" v-model="contact.fax" class="inputText" @input="() => validators.contact.validateFax()"  :value="111111111"/>
                                    
                                        <div class="errorMessages" v-if="validators.contact.errors.fax">
                                        <ErrorMessage>{{__(validators.contact.errors.fax)}}</ErrorMessage>
                                    </div>
                                </dd>
                            </fieldset>
                        
                        </div>
                    </div>
                    <dt>
                    </dt>

                    <!-- Stellvertrer togglable button -->
                    <dd class="flex-wrap w-80 form-control">
                        <label for="toggleDeputy" class="flex items-center cursor-pointer">
                            <div class="relative">
                                <input type="checkbox" id="toggleDeputy" class="sr-only" v-model="hasDeputy" style="position: absolute; left: -9999px;">
                                <div class="block bg-gray-300 rounded-full w-14 h-7"></div>
                                <div style="margin-top: -26px;" class="absolute w-6 h-5 transition bg-white rounded-full dot" :class="{ 'left-1': !hasDeputy, 'toggleButtonM': hasDeputy }"></div>
                            </div>
                            <div class="ml-16 text-gray-700" style="margin-top: -26px;">{{ __('page_setcontact.enter_deputy') }}</div>
                        </label>
                    </dd>

                    <fieldset v-if="hasDeputy" class="p-4">
                        <h2>{{ __('page_setcontact.deputy_header') }}</h2>
                        <dt>
                            <label class="required labelText">{{ __('page_setcontact.salutation') }}</label>
                        </dt>
                        <dd>
                            <select v-model="deputy.salutation" class="S inputText"
                                    @change="validators.deputy.validateSalutation()">

                                <option value="">{{ __('common.please_select') }}</option>
                                <option v-for="salutation in salutations"
                                        :value="salutation.value" :key="salutation.value">{{salutation.label}}
                                </option>
                            </select>
                            <div class="errorMessages" v-if="validators.deputy.errors.salutation">
                                <ErrorMessage>{{__(validators.deputy.errors.salutation)}}</ErrorMessage>
                            </div>
                        </dd>

                        <dt>
                            <label class="S required labelText">{{ __('page_setcontact.firstname') }}</label>
                            <label class="L required labelText">{{ __('page_setcontact.lastname') }}</label>
                        </dt>
                        <dd>
                            <input type="text" v-model="deputy.firstname" class="S inputText"
                                @input="() => validators.deputy.validateFirstName()">
                            <input type="text" v-model="deputy.lastname" class="M inputText"  style="max-width: 376px;"
                                @input="() => validators.deputy.validateLastName()">
                            <div class="errorMessages"
                                v-if="validators.deputy.errors.firstname || validators.deputy.errors.lastname">
                                <ErrorMessage>{{__(validators.deputy.errors.firstname)}}</ErrorMessage>
                                <ErrorMessage>{{__(validators.deputy.errors.lastname)}}</ErrorMessage>
                            </div>
                        </dd>

                        <dt>
                            <label class="required labelText">{{ __('page_setcontact.email') }}</label>
                        </dt>
                        <dd>
                            <input type="email" v-model="deputy.email" class="L inputText"
                                @input="() => validators.deputy.validateEmail()">
                            <div class="errorMessages" v-if="validators.deputy.errors.email">
                                <ErrorMessage>{{__(validators.deputy.errors.email)}}</ErrorMessage>
                            </div>
                        </dd>

                        <dt>
                            <label class="required labelText">{{ __('page_setcontact.phone') }}</label>
                        </dt>
                        <dd>
                            <TelephoneInput :country="company.country" v-model="deputy.phone" class="inputText"
                                            @input="() => validators.deputy.validatePhone()"/>
                            <div class="errorMessages" v-if="validators.deputy.errors.phone">
                                <ErrorMessage>{{__(validators.deputy.errors.phone)}}</ErrorMessage>
                            </div>
                        </dd>
                    </fieldset>

                    
                    
                    <!-- alternative billing address togglebutton -->
                    <dd class="flex-wrap w-80 form-control">
                        <label for="toggleBilling" class="flex items-center cursor-pointer">
                            <div class="relative">
                                <input type="checkbox" id="toggleBilling" class="sr-only" v-model="hasBilling" style="position: absolute; left: -9999px;">
                                <div class="block bg-gray-300 rounded-full w-14 h-7"></div>
                                <div style="margin-top: -26px;" class="absolute w-6 h-5 transition bg-white rounded-full dot" :class="{ 'left-1': !hasBilling, 'toggleButtonM': hasBilling }"></div>
                            </div>
                            <div class="ml-16 text-gray-700" style="margin-top: -26px;">Alternative Rechnungsanschrift</div>
                        </label>
                    </dd>

                    <fieldset v-if="hasBilling" class="p-4">
                        <h2 v-if="$store.language === 'de'">Alternative Rechnungsanschrift</h2>
                        <h2 v-else>Alternative billing address</h2>

                        <dl class="form">
                            <dt>
                                <label  class="required labelText">{{ __('page_setcontact.company') }}</label>
                            </dt>
                            <dd>
                                <input type="text" class="L inputText"
                                    v-model="billing.name"
                                    @input="validators.billing.validateName()">
                                <div class="errorMessages" v-if="validators.billing.errors.name">
                                    <ErrorMessage>{{__(validators.billing.errors.name)}}</ErrorMessage>
                                </div>
                            </dd>

                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.address') }}</label>
                            </dt>
                            <dd>
                                <input type="text" class="L inputText" v-model="billing.street1"
                                    @input="validators.billing.validateAddress()">
                            </dd>
                            <dd>
                                <input type="text" class="L inputText" v-model="billing.street2"
                                    @input="validators.billing.validateAddress()">
                                <div class="errorMessages" v-if="validators.billing.errors.address">
                                    <ErrorMessage>{{__(validators.billing.errors.address)}}</ErrorMessage>
                                </div>
                            </dd>
                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.zipcode') }}</label>
                                <label style="padding-left:50px;" class="required labelText">{{ __('page_setcontact.city') }}</label>
                            </dt>
                            <dd>
                                <input type="text" v-model="billing.zip" class="S inputText"
                                    @input="validators.billing.validateZip()">                           
                                <input type="text" v-model="billing.city" class="L inputText"
                                    @input="validators.billing.validateCity()">
                                <div class="errorMessages"
                                    v-if="validators.billing.errors.city || validators.billing.errors.zip">
                                    <ErrorMessage>{{__(validators.billing.errors.zip)}}</ErrorMessage>
                                    <ErrorMessage>{{__(validators.billing.errors.city)}}</ErrorMessage>
                                </div>
                            </dd>

                            <dt>
                                <label class="required labelText">{{ __('page_setcontact.country') }}</label>
                            </dt>
                            <dd>
                                <select v-model="billing.country" class="L inputText"
                                        @change="validators.billing.validateCountry()">
                                    <option value="">{{ __('common.please_select') }}</option>
                                    <option v-for="country in countries"
                                            :value="country.val" :key="country.val">{{country.label}}
                                    </option>
                                </select>
                                <div class="errorMessages" v-if="validators.billing.errors.country">
                                    <ErrorMessage>{{__(validators.billing.errors.country)}}</ErrorMessage>
                                </div>
                            </dd>
                        </dl>
                    </fieldset>
                </dl>
                <footer>
                    <button @click="validateAndSubmitForm(); scrollToTop()" type="button" :disabled="!!validators.vatid.errors.vatid && needsVat" class="buttonSubmitAlign right btn-secondary">
                        <span>{{ __('common.button_continue') }} ></span>
                    </button>
                </footer>
            </div>
        </div>
    </form>
</template>

<script>
import _ from 'lodash';
import Api from '../api/Api';
import ErrorMessage from "./ErrorMessage";
import ContactValidator from "../validators/ContactValidator";
import TelephoneInput from "./TelephoneInput";
import Contact from "../domain/contact";
import Address from "../domain/address";
import AddressValidator from "../validators/AddressValidator";
import BillingValidator from "../validators/BillingValidator";
import VatValidator from "../validators/VatValidator";
import PasswordValidator from "../validators/PasswordValidator";
import EUCountries from '../utils/EUCountries';
import VoucherValidator from "../validators/VoucherValidator";
import Lang from "../mixins/Lang";
import Login from "./Login";
import Account from "../api/Account";

export default {
        name: "ContactForm",
        components: {Login, TelephoneInput, ErrorMessage},
        props: [],
        store: ['translations', 'countries', 'registration', 'vatCountries', 'vatZipCodes'],
        mixins: [Lang],

        created() {
            this.contact = this.registration.contact || this.contact;
            this.company = this.registration.company || this.company;
            this.hasDeputy = this.registration.hasDeputy || this.hasDeputy;
            this.deputy = this.registration.deputy || this.deputy;
            this.hasBilling = this.registration.hasBilling || this.hasBilling;
            this.billing = this.registration.billing || this.billing;
            this.vouchercode = this.registration.vouchercode || this.vouchercode;
            this.createUserAccount = this.registration.createUserAccount;
            this.password = this.registration.password || this.password;
            this.confirmPassword = this.registration.password || this.password;

            this.validators = {
                contact: new ContactValidator(this.contact),
                deputy: new ContactValidator(this.deputy),
                company: new AddressValidator(this.company, this.vatZipCodes),
                billing: new BillingValidator(this.billing),
                vatid: new VatValidator(this.company.vatid, this.company.country, this.vatCountries),
                password: new PasswordValidator(this.password, this.confirmPassword),
                vouchercode: new VoucherValidator(this.vouchercode)
            }
        },

        computed: {
            salutations() {
                return [
                    {value: 'm', label: this.__('common.salutation_male')},
                    {value: 'f', label: this.__('common.salutation_female')}
                ];
            },
            needsVat() {

                const result = this.vatCountries.find(obj => obj.id === this.company.country);

                if(result) {
                    return true;
                    
                } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.company.vatid = null;
                    return false;
                }
            }
        },

        watch: {
            'company.vatid': function() {
                this.validators.vatid.vatid = this.company.vatid;
                this.validators.vatid.validateVatForm(this.vatCountries);
            },
            // 'contact.email' : 'checkAccount', // this is triggered through contactvalidator
            'company.city' : 'checkAccount',
            'company.name' : 'checkAccount',

            'company.country': function() {
                this.validators.vatid.country = this.company.country;
                this.validators.vatid.validateVatForm(this.vatCountries);
            },
            password() {
                this.validators.password.password = this.password;
                this.validators.password.validatePassword();
                this.validators.password.confirmPassword = this.confirmPassword;
                this.validators.password.validateConfirmPassword();
            },

            confirmPassword() {
                this.validators.password.confirmPassword = this.confirmPassword;
                this.validators.password.validateConfirmPassword();
            }
        },

        methods: {
            checkAccount() {
                let city = this.company.city;
                let email = this.contact.email;
                let company = this.company.name;
                Account.check(company,city,email).then(({status, data}) => {
                    if(status === 200 && data.success && data.available) {
                        this.matchedAvailableAccount = data.user;
                    } else {
                        this.matchedAvailableAccount = "";
                    }
                });
            },
            isInEU(country) {
                return _.find(EUCountries, (code) => code === country);
            },
            validateAndSubmitForm() {
                console.log('validateAndSubmitForm');
                _.each(this.validators, (validator) => {
                    // console.log('validating:',validator);
                    validator.validateAll();
                });


                let validators = this.validators;

                let excludedValidators = [validators.vouchercode];

                if (!this.hasDeputy) {
                    excludedValidators.push(validators.deputy);
                }

                if (!this.hasBilling) {
                    excludedValidators.push(validators.billing);
                }
                
                if (!this.createUserAccount) {
                    excludedValidators.push(validators.password);
                }

                let hasValidatonErrors = _.chain(this.validators)
                    .reject((validator) => {
                        return _.includes(excludedValidators, validator);
                    })
                    .some((validator) => {
                        _.forEach(validator.errors, (value) => {
                        if (value !== "") {
                            console.log("Validation error triggered by:", value);
                        }
                        });
                        return _.some(validator.errors, (value) => value !== "");
                    })
                    .value();
                if (hasValidatonErrors) {          
                    // eslint-disable-next-line          
                    console.log("Has validation errors!");
                    return; // not submitting if.
                } 

                
                // if this is a new user, we need to check if the email is available.
                if(this.createUserAccount) {
                    // check that email does not exist.
                    let dupes =  Api.post(`/check/email`, {email: this.contact.email});
                    dupes.then((response) => {
                        if(response.data.success){
                            // save company in localstorage (overwrite if exists)
                            window.localStorage.setItem('companyName', JSON.stringify(this.company.name));
                            // let companyName = JSON.parse(localStorage.getItem('companyName'));
                            this.$emit('submitContactForm', {
                                contact: this.contact,
                                company: this.company,
                                hasDeputy: this.hasDeputy,
                                deputy: this.deputy,
                                hasBilling: this.hasBilling,
                                billing: this.billing,
                                vouchercode: this.vouchercode,
                                createUserAccount: this.createUserAccount,
                                password: this.password,
                            });
                        }else{
                            return;
                        }
                    });
                } else {
                    // save company in localstorage (overwrite if exists)
                    window.localStorage.setItem('companyName', JSON.stringify(this.company.name));
                    // let companyName = JSON.parse(localStorage.getItem('companyName'));
                    this.$emit('submitContactForm', {
                        contact: this.contact,
                        company: this.company,
                        hasDeputy: this.hasDeputy,
                        deputy: this.deputy,
                        hasBilling: this.hasBilling,
                        billing: this.billing,
                        vouchercode: this.vouchercode,
                        createUserAccount: this.createUserAccount,
                        password: this.password,
                    });
                }


                
                
                
            },

            loginSuccess(data) {
                this.registration.interessent_id = data.id;
                this.registration.vouchercode = data.vouchercode;

                this.registration.company.name = data.company;
                this.registration.company.master_brewer = data.master_brewer;
                this.registration.company.future_award = data.future_award;
                this.registration.company.street1 = data.street1;
                this.registration.company.street2 = data.street2;
                this.registration.company.city = data.city;
                this.registration.company.zip = data.zip;
                this.registration.company.country = data.country_id;
                this.registration.company.url_company = data.url_company;
                this.registration.company.po_number = data.po_number;
                this.company.vatid = data.vatid;

                this.registration.contact.email = data.contact_email;
                this.registration.contact.fax = data.contact_fax;
                this.registration.contact.firstname = data.contact_firstname;
                this.registration.contact.lastname = data.contact_lastname;
                this.registration.contact.phone = data.contact_phone;
                this.registration.contact.salutation = data.contact_salutation;

                if (data.deputy_email) {
                    this.registration.deputy.email = data.deputy_email;
                }
                if (data.deputy_firstname) {
                    this.registration.deputy.firstname = data.deputy_firstname;
                }
                if (data.deputy_lastname) {
                    this.registration.deputy.lastname = data.deputy_lastname;
                }
                if (data.deputy_phone) {
                    this.registration.deputy.phone = data.deputy_phone;
                }
                if (data.deputy_salutation) {
                    this.registration.deputy.salutation = data.deputy_salutation;
                }

                if (data.deputy_email || data.deputy_firstname || data.deputy_lastname || data.deputy_phone || data.deputy_salutation) {
                    this.hasDeputy = true;
                }

              if (data.billing_address_company) {
                this.registration.billing.name = data.billing_address_company;
              }
              if (data.billing_address_street1) {
                this.registration.billing.street1 = data.billing_address_street1;
              }
              if (data.billing_address_street2) {
                this.registration.billing.street2 = data.billing_address_street2;
              }
              if (data.billing_address_zip) {
                this.registration.billing.zip = data.billing_address_zip;
              }
              if (data.billing_address_city) {
                this.registration.billing.city = data.billing_address_city;
              }
              if (data.billing_address_country_id) {
                this.registration.billing.country = data.billing_address_country_id;
              }

              this.createUserAccount = false;
            },
            loginRegisterStatus(showLogin) {
                this.showLogin = showLogin;

                if(!showLogin) {
                    this.createUserAccount = true;
                } else {
                    this.createUserAccount = false;
                }
            },

            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }

        },

        data() {
            return {
                validators: {},
                company: new Address(),
                hasBilling: false,
                billing: new Address(),
                contact: new Contact(),
                hasDeputy: false,
                deputy: new Contact(),
                vouchercode: "",
                createUserAccount: false,
                password: "",
                confirmPassword: "",
                matchedAvailableAccount : "",
                vatNeeded : false,
                showLogin : true,   // true if it is login.
            }
        }
    }
</script>

<style scoped lang="scss">
    p.bg-info {
        margin-top: 5px;
    }

    button.buttonSubmit, button.buttonReset {
        &.right {
            span {
                margin-right: 5px;
            }
        }

        &.left {

            span {
                margin-left: 5px;
            }
        }
    }

    div.ng-scope .modal-dialog {
        width: 650px;
    }

    #loginRegisterForm {
        /*display: flex;
        flex-direction: column;*/
        align-items: center;
    }

    .label-input input {
        width: 300px;
    }

    .label-input {
        text-align: left;
    }

</style>